import { useContext } from 'react';
import { IDCONSELHOChartsDataContext } from '../contexts/IDCONSELHOChartsDataContext';

export const useIDCONSELHOChartsDataContext = () => {
    return useContext(IDCONSELHOChartsDataContext);
};